import {
	Building2,
	FileText,
	Trees,
	Warehouse,
	Users,
	Tractor,
	Truck,
	Share2,
	Tags,
	Sprout,
	Apple,
	Wheat,
	Boxes,
	ListChecks,
	Sun,
	Target,
	Wrench,
	Droplets,
	Building,
	Package,
	Plug,
	SlidersVertical,
} from "lucide-react";

export const ICON_MAP = {
	Building: Building,
	Users: Users,
	Tags: Tags,
	Package: Package,
	Building2: Building2,
	FileText: FileText,
	Trees: Trees,
	Warehouse: Warehouse,
	Tractor: Tractor,
	Truck: Truck,
	Share2: Share2,
	Sprout: Sprout,
	Apple: Apple,
	Wheat: Wheat,
	Boxes: Boxes,
	ListChecks: ListChecks,
	Sun: Sun,
	Target: Target,
	Wrench: Wrench,
	Droplets: Droplets,
	Plug: Plug,
	SlidersVertical: SlidersVertical,
};

export const getIcon = (iconName) => {
	return ICON_MAP[iconName] || FileText;
};
